module.exports = __webpack_public_path__ + "img/info.e2be8faf.svg";